import { useSelector } from 'react-redux'
import { StateExtended } from '../../_config/interfaces'
import { normalizeLanguage } from '../../i18n'

export function useFpLoaderSelector() {
    const show = useSelector((state: StateExtended) => state.loader.fpLoader)
    return show
}
export function useLanguageSelector() {
    const lang = useSelector((state: StateExtended) => normalizeLanguage(state?.loader?.lang))
    return lang
}
